export default "__VITE_ASSET__CUNpPL60__"